"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatedEligibilityCampaignToJSON = exports.ValidatedEligibilityCampaignFromJSONTyped = exports.ValidatedEligibilityCampaignFromJSON = exports.instanceOfValidatedEligibilityCampaign = void 0;
var runtime_1 = require("../runtime");
var ValidatedEligibilityAdSet_1 = require("./ValidatedEligibilityAdSet");
var ValidatedEligibilityCampaignCampaignSchedule_1 = require("./ValidatedEligibilityCampaignCampaignSchedule");
/**
 * Check if a given object implements the ValidatedEligibilityCampaign interface.
 */
function instanceOfValidatedEligibilityCampaign(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfValidatedEligibilityCampaign = instanceOfValidatedEligibilityCampaign;
function ValidatedEligibilityCampaignFromJSON(json) {
    return ValidatedEligibilityCampaignFromJSONTyped(json, false);
}
exports.ValidatedEligibilityCampaignFromJSON = ValidatedEligibilityCampaignFromJSON;
function ValidatedEligibilityCampaignFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'salesforceOpportunity': !(0, runtime_1.exists)(json, 'salesforce_opportunity') ? undefined : json['salesforce_opportunity'],
        'campaignSchedule': !(0, runtime_1.exists)(json, 'campaign_schedule') ? undefined : (0, ValidatedEligibilityCampaignCampaignSchedule_1.ValidatedEligibilityCampaignCampaignScheduleFromJSON)(json['campaign_schedule']),
        'markets': !(0, runtime_1.exists)(json, 'markets') ? undefined : json['markets'],
        'languages': !(0, runtime_1.exists)(json, 'languages') ? undefined : json['languages'],
        'errorCodes': !(0, runtime_1.exists)(json, 'error_codes') ? undefined : json['error_codes'],
        'eligibilityAdSets': !(0, runtime_1.exists)(json, 'eligibility_ad_sets') ? undefined : (json['eligibility_ad_sets'].map(ValidatedEligibilityAdSet_1.ValidatedEligibilityAdSetFromJSON)),
    };
}
exports.ValidatedEligibilityCampaignFromJSONTyped = ValidatedEligibilityCampaignFromJSONTyped;
function ValidatedEligibilityCampaignToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'salesforce_opportunity': value.salesforceOpportunity,
        'campaign_schedule': (0, ValidatedEligibilityCampaignCampaignSchedule_1.ValidatedEligibilityCampaignCampaignScheduleToJSON)(value.campaignSchedule),
        'markets': value.markets,
        'languages': value.languages,
        'error_codes': value.errorCodes,
        'eligibility_ad_sets': value.eligibilityAdSets === undefined ? undefined : (value.eligibilityAdSets.map(ValidatedEligibilityAdSet_1.ValidatedEligibilityAdSetToJSON)),
    };
}
exports.ValidatedEligibilityCampaignToJSON = ValidatedEligibilityCampaignToJSON;
